export default "__VITE_ASSET__De9YBoSw__"